import React, { useEffect, useState } from 'react'
import styled from 'styled-components'
import { isNil } from 'ramda'

export const Checkbox = ({
  disabled,
  value,
  isChecked,
  label,
  name,
  onChange
}) => {
  const [checked, setChecked] = useState(value || false)

  useEffect(() => {
    setChecked(value)
  }, [value])

  const handleChange = e => {
    setChecked(e.target.checked)
    onChange(name, e.target.checked)
  }

  return (
    <Wrapper>
      <CheckboxLabel disabled={disabled} valid>
        {label}
        <CheckboxInput
          disabled={disabled}
          type='checkbox'
          checked={!isNil(isChecked) ? isChecked : checked}
          onChange={handleChange}
        />
        <CheckboxMark valid />
      </CheckboxLabel>
    </Wrapper>
  )
}

Checkbox.defaultProps = {
  isChecked: null,
  onChange: () => {},
  validate: () => {},
  disabled: false,
  value: false,
  label: '',
  name: '',
}

export default Checkbox

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 15px;
`

const CheckboxLabel = styled.label`
  box-sizing: border-box;
  display: inline-block;
  position: relative;
  padding-left: 30px;
  width: 100%;
  cursor: pointer;
  font-size: 14px;
  line-height: 16px;
  color: ${({ theme, valid }) => valid ? 'inherit' : theme.colors.error};
  opacity: ${({ disabled }) => disabled ? '.5' : '1'};
`

const CheckboxInput = styled.input`
  position: absolute;
  opacity: 0;
  cursor: pointer;
  height: 0;
  width: 0;
`

const CheckboxMark = styled.span`
  position: absolute;
  top: 0;
  left: 0;
  height: 14px;
  width: 14px;
  border-radius: 4px;
  background-color: #fff;
  border-color: ${({ theme, valid }) => valid
    ? theme.colors.primary.main
    : theme.colors.error};
  border-width: 2px;
  border-style: solid;
  transition: all .3s;
  
  &::after {
    content: '';
    position: absolute;
    display: none;
    left: 2px;
    top: -1px;
    width: 4px;
    height: 7px;
    border: solid white;
    border-width: 0 2px 2px 0;
    transform: rotate(45deg);
  }
  ${CheckboxLabel} ${CheckboxInput}:checked ~ & {
    background-color: ${({ theme }) => theme.colors.secondary.main};
    border-color: ${({ theme }) => theme.colors.secondary.main};
  }
  ${CheckboxLabel} ${CheckboxInput}:checked ~ &::after {
    display: block;
  }
`
